/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const exampleSchema = z.object({
  text: z.string(),
  translation: z.string().nullable(),
});

const translationSchema = z.object({
  lang: z.string(),
  title: z.string().nullable(),
  definition: z.string().nullable(),
  usageNotes: z.string().nullable(),
});

const detailDataSchema = z.object({
  id: z.number(),
  title: z.string(),
  definition: z.string(),
  usageNotes: z.string().nullable(),
  examples: z.array(exampleSchema),
  translation: translationSchema.nullable(),
  currentUserOpenIssueId: z.number().nullable(),
});

export interface IChallengeTriageDetailExample {
  text: string;
  translation: string | null;
}

export interface IChallengeTriageDetailTranslation {
  lang: string;
  title: string | null;
  definition: string | null;
  usageNotes: string | null;
}

export interface IChallengeTriageDetailData {
  id: number;
  title: string;
  definition: string;
  usageNotes: string | null;
  examples: IChallengeTriageDetailExample[];
  translation: IChallengeTriageDetailTranslation | null;
  currentUserOpenIssueId: number | null;
}

export const getChallengeTriageDetailResponseSchema = createApiResponseSchema(
  detailDataSchema,
) as z.ZodSchema<IAPI<IChallengeTriageDetailData>>;

export type IGetChallengeTriageDetailResponse = IAPI<IChallengeTriageDetailData>;
